import React from 'react';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';

//styled-components
import {GuideCardLink, GuideCardStatic, HeadingDesktop, HeadingMobile} from './styles';

const GuideCardBase = ({
  device,
  imageSizes,
  guide,
  params,
  shouldShowSpinnerWhileLoading = false,
  shouldShowAnimationWhileLoading = false,
  store,
  route
}) => {
  const {imageUrl, title} = guide;
  const isLink = store && store.router && route;
  const isMobile = device === 'mobile';

  const GuideCard = isLink ? GuideCardLink : GuideCardStatic;
  const Heading = isMobile ? HeadingMobile : HeadingDesktop;
  const metadata = guide.metadata ? guide.metadata : guide.media && guide.media.metadata ? guide.media.metadata : {};
  const dataCyGuideTitle = `guide-title-${title.split(' ').join('-')}`;

  return (
    <GuideCard store={store} route={route} params={params} isLink={isLink} device={device} data-cy="guide-card">
      <CloudinaryPicture
        aspectRatio={4 / 3}
        metadata={metadata}
        shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
        shouldShowAnimationWhileLoading={shouldShowAnimationWhileLoading}
        src={imageUrl}
        sizes={imageSizes}
      />
      <Heading maxLines={3} dataCy={dataCyGuideTitle}>
        {title}
      </Heading>
    </GuideCard>
  );
};

export const GuideCardDesktop = props => <GuideCardBase device="desktop" {...props} />;

export const GuideCardMobile = props => <GuideCardBase device="mobile" {...props} />;
